
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign",
      function () {
        return require("private-next-pages/sign.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sign"])
      });
    }
  